'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanElementTransform = exports.isCleanElement = exports.isFormElement = exports.isDangerousElement = exports.isBlockElement = exports.isInlineElement = exports.isSelfClosingElement = undefined;

var _string_utilities = require('./string_utilities');

/**
 * TODO: The lists of elements that are used to create functional
 * utilities in this script might be slightly more mantainable
 * if we just kept them in a bunch of JSON files - even if this
 * is it's own module.
 */

/**
 * References to self closing tags can be used for validation at
 * least... self closing tags should not have children. All sets
 * are coerced into objects as they are quicker to index.
 */
var SELF_CLOSING_ELEMENTS = ['area', 'base', 'br', 'col', 'command', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr'];

/**
 * Returns true if the provided tag name is
 * the tag name of a self closing tag.
 *
 * @param {String}
 *
 * @returns {Boolean}
 */
var isSelfClosingElement = exports.isSelfClosingElement = (0, _string_utilities.createMatchFn)(SELF_CLOSING_ELEMENTS);

/**
 * When manipulating text we can used the layout style of the
 * containing element to figure out if we should be padding strings
 * as we're transforming them. There are far fewer inline elements
 * than there are block elements, so we can just treat block as
 * the mutual exclusion of this set.
 */
var INLINE_ELEMENTS = ['b', 'big', 'i', 'small', 'tt', 'abbr', 'acronym', 'cite', 'code', 'dfn', 'em', 'kbd', 'strong', 'samp', 'time', 'var', 'a', 'bdo', 'br', 'img', 'map', 'object', 'q', 'script', 'span', 'sub', 'sup', 'button', 'input', 'label', 'select', 'textarea'];

/**
 * Returns true if the tag name is that
 * of an inline type element.
 *
 * @param {String}
 *
 * @returns {Boolean}
 */
var isInlineElement = exports.isInlineElement = (0, _string_utilities.createMatchFn)(INLINE_ELEMENTS);

/**
 * Returns true if the tag name is that
 * of an block level element.
 *
 * @param {String}
 *
 * @returns {Boolean}
 */
var isBlockElement = exports.isBlockElement = function isBlockElement(str) {
  return !isInlineElement(str);
};

/**
 * The set of tags that we consider dangerous, and whose
 * content should be completely stripped during sanitization.
 */
var DANGEROUS_ELEMENTS = ['iframe', 'script', 'style', 'textarea'];

/**
 * Returns true if the tag name is that
 * of a potentially dangerous element (where
 * that element is present in foreign markup)
 *
 * @param {String}
 *
 * @returns {Boolean}
 */
var isDangerousElement = exports.isDangerousElement = (0, _string_utilities.createMatchFn)(DANGEROUS_ELEMENTS);

var FORM_ELEMENTS = ['textarea', 'input', 'select', 'option', 'button', 'form'];

var isFormElement = exports.isFormElement = (0, _string_utilities.createMatchFn)(FORM_ELEMENTS);

var CLEAN_TAGS = ['div', 'p', 'a', 'img', 'b', 'strong', 'i', 'em', 'h1', 'h2', 'h3', 'h4', 'h4', 'h5', 'h6', 'ol', 'ul', 'li', 'br'];

/**
 * Asserts whether a tag is allowed inside content.
 *
 * @param {String}
 *
 * @returns {Boolean}
 */
var isCleanElement = exports.isCleanElement = (0, _string_utilities.createMatchFn)(CLEAN_TAGS);

var CLEAN_ELEMENT_TABLE = {
  div: 'p',
  b: 'strong',
  i: 'em',
  h1: 'h4',
  h2: 'h4',
  h3: 'h4',
  h5: 'h4',
  h6: 'h4',
  ol: 'ul'
};

/**
 * Used for determining if an element transform is required...
 * given the tag name of any element, it will return the
 * corresponding transformation that's required (bu `cleanup`).
 *
 * @param {String}
 *
 * @returns {String}
 */
var cleanElementTransform = exports.cleanElementTransform = (0, _string_utilities.createLookupFn)(CLEAN_ELEMENT_TABLE);